// EmdgFooter.tsx

import React, { ReactNode } from 'react'

interface EmdgFooterProps {
    dark?: boolean;
    alt?: boolean;
    children: ReactNode;
    className?: string;
    attributeOptions?: React.HTMLAttributes<HTMLElement>;
}

const EmdgFooter: React.FC<EmdgFooterProps> = ({
  dark, alt, children, className = '', attributeOptions = {},
}) => (
  <footer
    className={`emdg-footer ${className}${dark ? ' emdg-footer--dark' : ''}${alt ? ' emdg-footer--alt' : ''}`}
    {...attributeOptions}
    role="contentinfo"
  >
    {children}
  </footer>
)

export default EmdgFooter
